import BaseSyncError from "scripts/exceptions/baseSyncError";

class SubscriptionSyncError extends BaseSyncError {}

export default SubscriptionSyncError;
